export const capitalizeString = (str: string): string => {
  return str ? str.replace(/^./, (match) => match.toUpperCase()) : str;
};
